// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_19d6a3c","betDetails":"_8451db5"};